<template>
  <v-app style="background: rgba(0,0,0,0);">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App',
}
</script>
